module.exports = __webpack_public_path__ + "static/img/sit_back_relax_couple.456dd696.svg";